var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconEditSelectTree(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1408_17967)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.4001 17.1649H6.60001C6.2688 17.1649 6 16.896 6 16.5648C6 16.2336 6.2688 15.9648 6.60001 15.9648H17.4001C17.7313 15.9648 18.0001 16.2336 18.0001 16.5648C18.0001 16.896 17.7313 17.1649 17.4001 17.1649Z",
    fill: "#1A1919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.599841 17.1648C0.442222 17.1648 0.289437 17.1032 0.175764 16.9888C0.0285453 16.8416 -0.0313675 16.6296 0.015801 16.4272L0.887832 12.7271C0.913467 12.6184 0.968546 12.5191 1.04779 12.4407L12.0791 1.40946C12.7576 0.730205 13.9447 0.728593 14.6247 1.40946L15.756 2.54062C16.096 2.88062 16.2832 3.33267 16.2832 3.81344C16.2832 4.29435 16.096 4.74714 15.756 5.08626L4.72459 16.1168C4.64549 16.196 4.54617 16.2513 4.43821 16.2768L0.738123 17.1488C0.691834 17.1601 0.645398 17.1648 0.599841 17.1648ZM2.01665 13.168L1.40625 15.7583L3.9967 15.1479L14.9071 4.23752C15.0208 4.12384 15.0832 3.97355 15.0832 3.81344C15.0832 3.65348 15.0208 3.5023 14.9071 3.38951L13.776 2.25747C13.5495 2.031 13.1535 2.031 12.928 2.25747L2.01665 13.168ZM4.29978 15.6929H4.30784H4.29978Z",
    fill: "#1A1919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9111 7.68184C12.7576 7.68184 12.6039 7.62339 12.4871 7.50577L9.65821 4.67698C9.42383 4.4426 9.42383 4.06261 9.65821 3.82824C9.89273 3.59371 10.2727 3.59371 10.5071 3.82824L13.3359 6.65703C13.5703 6.8914 13.5703 7.27139 13.3359 7.50577C13.2183 7.62339 13.0647 7.68184 12.9111 7.68184Z",
    fill: "#1A1919"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1408_17967"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEditSelectTree);
export default __webpack_public_path__ + "static/media/icon-edit-select-tree.2429c26d3e0a2c1a215e41fc06a1fb61.svg";
export { ForwardRef as ReactComponent };